import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { Service } from 'src/app/services';
import { LoadingScreenService } from 'src/app/services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-streaming-device',
  templateUrl: './streaming-device.component.html',
  styleUrls: ['./streaming-device.component.sass']
})
export class StreamingDeviceComponent implements OnInit {
  @Input() infoStreaming: any;
  @Input() itemsCart: any;
  @Input() indexTab: number;
  @Input() selectsToDisplay: any;
  @Input() selectMonthlyRent: any;
  @Input() selectPayToday: any;
  @Output() selectPayTodayOut = new EventEmitter<any>();
  @Output() selectMonthlyRentOut = new EventEmitter<any>();
  @Output() selectsToDisplayOut = new EventEmitter<any>();
  @Output() closeTab = new EventEmitter<number>();
  @Output() updateinfoStreaming = new EventEmitter<any>();
  @Output() next = new EventEmitter<any>();
  @Output() selectsToDisplayFullOut = new EventEmitter<any>();
  public loadStreaming: boolean = false;
  public continue: boolean = false;
  public quantityAccessories: number = 0;
  public viewMonths: boolean = true;
  public priceMonth: number = 0;
  public month: number = 0;
  public prices: any;
  public regularPrice: number = 0;
  public regularPriceCheck: boolean = false;
  public quantitiesAvailable: number = 0;
  public checkTerms: boolean = false;
  public quantity: number = 1;
  public cartIdStreaming: number = 0;
  public contract: boolean = true;
  public mounth: boolean = true;
  public contractSelect: any = [];
  public amountPayable: number = 0;
  public quantityDevices: number = 1;
  public typeOfContract = '';
  public typeDefaultContract: number = 24;
  public data: any;
  public imgDevice: string = '';
  public contractInMoths = 0;
  public contractIndex = 0;
  public selectsToDisplayFull: any = [];
  constructor(private loadingScreenService: LoadingScreenService, public global: GlobalService, private services: Service) { }
  ngOnInit(): void {
    this.global.tokenShop=sessionStorage.getItem("tokenShop");
    this.data = this.infoStreaming.iptvContracts;
    for (let i = 0; i < this.data.contracts.length; i++) {
      this.contractSelect[i] = false;
      if (this.data.contracts[i].contractInMoths == this.typeDefaultContract) {
        this.calculateAmountToPay(this.data.contracts[i].contractInMoths, i);
      }
    }
    this.regularPrice = this.infoStreaming.colors[0].storages[0].products[0].regular_price;
    this.quantitiesAvailable = this.infoStreaming.colors[0].storages[0].products[0].stock;
    this.loadEditionStreaming();
    this.loadStreaming = true;
  }
  loadEditionStreaming() {
    let sum = 0;
    let qty = 0;
    let installments = 0;
    let hasEdit: boolean = false;
    for (let i = 0; i < this.itemsCart.products.length; i++) {
      if (this.itemsCart.products[i].iptv == true && this.itemsCart.products[i].equipment == true) {
        sum = this.itemsCart.products[i].decTotalPrice;
        qty += this.itemsCart.products[i].qty;
        installments = this.itemsCart.products[i].installments;
        hasEdit = true;
      }
    }
    if (hasEdit == true) {
      this.checkTerms = true;
      this.quantity = qty;
      if (this.itemsCart.intContractMonths > 0) {
        this.contract = true;
        for (let i = 0; i < this.data.contracts.length; i++) {
          this.contractSelect[i] = false;
          if (this.data.contracts[i].contractInMoths == this.itemsCart.intContractMonths) {
            this.calculateAmountToPay(this.data.contracts[i].contractInMoths, i);
          }
        }
        if (installments > 0) {
          this.regularPriceCheck = false;
          for (let i = 0; i < this.prices.length; i++) {
            if (this.prices[i].intMonths == installments) {
              this.selectMonths(i);
            }
          }
        }
        else {
          this.regularPriceCheck = true;
        }
      }
      else {
        this.contract = false;
        this.contractInMoths=0;
        this.amountPayable = sum;
      }
      this.selectMonthlyRent[this.indexTab]=this.priceMonth;
      this.selectMonthlyRentOut.emit(this.selectMonthlyRent);

      this.selectPayToday[this.indexTab] = this.amountPayable;
      this.selectPayTodayOut.emit(this.selectPayToday);
    }
  }
  paymentInstallments() {
    this.imgDevice = this.infoStreaming.colors[0].storages[0].products[0].imgUrl;
    this.prices = this.infoStreaming.colors[0].storages[0].products[0].prices;
    let defaul:boolean=false;
    for (let i = 0; i < this.prices.length; i++) {
      if(this.prices[i].intMonths<=this.contractInMoths){
        this.prices[i].view=true;
      }
      else{
        this.prices[i].view=false;
      }
      if (this.prices[i].defaultPrice == true && this.prices[i].view==true) {
        defaul=true;
        this.month = this.prices[i].intMonths;
        this.selectMonths(i);
      }
    }
    for (let i = 0; i < this.prices.length; i++) {
      if(defaul==false){
        if(this.prices[i].view){
          defaul=true;
          this.month = this.prices[i].intMonths;
          this.selectMonths(i); 
        }
      }
    }
    this.priceMonth = this.amountPayable / this.month;
  }
  calculateAmountToPay(opt: string, index = 0) {
    if (opt == 'contract' || opt == 'withoutContract') {
      if (opt == 'withoutContract') {
        if(this.quantity>1){
          this.amountPayable = (this.data.noContract.regularPrice * this.quantity)-this.data.noContract.regularPrice;
          /*
          if(this.data.noContract.regularPrice>0){
            this.amountPayable = (this.data.noContract.regularPrice * this.quantity)-this.data.noContract.regularPrice;
          }
          else{
            this.amountPayable=0;
          }
          */
        }
        else{
          this.amountPayable=0;
        }
        this.paymentInstallments();
        this.typeOfContract = 'Sin Contrato';
        this.contractInMoths = 0;
        this.contractIndex = 0;
        this.contract = false;
        this.selectPaymentMethods(false);
      }
      if (opt == 'contract') {
        this.viewMonths = true;
        for (let i = 0; i < this.data.contracts.length; i++) {
          if (this.data.contracts[i].contractInMoths == this.typeDefaultContract) {
            this.calculateAmountToPay(this.data.contracts[i].contractInMoths, i);
          }
        }
      }
    }
    else {
      this.contract = true;
      for (let i = 0; i < this.data.contracts.length; i++) {
        this.contractSelect[i] = false;
      }
      this.contractSelect[index] = true;
      this.contractInMoths = this.data.contracts[index].contractInMoths;
      this.contractIndex = index;
      this.typeOfContract = 'Pago en ' + this.data.contracts[index].contractInMoths + ' meses';
      this.amountPayable = (this.data.contracts[index].regularPrice - (this.data.contracts[index].regularPrice * (this.data.contracts[index].firtsProductDiscount / 100)));
      if (this.quantity > 1) {
        let amount = 0;
        for (let i = 1; i < this.quantity; i++) {
          amount += this.data.contracts[index].regularPrice;
        }
        this.amountPayable = this.amountPayable + amount;
      }
      this.paymentInstallments();
    }
  }
  nextTab() {
    let streaming: any = [];
    for (let i = 0; i < this.itemsCart.products.length; i++) {
      if (this.itemsCart.products[i].iptv == true && this.itemsCart.products[i].equipment == true) {
        streaming.push(this.itemsCart.products[i].cartId);
      }
    }
    for (let i = 0; i < streaming.length; i++) {
      this.loadingScreenService.startLoading();
      this.services.deleteItem(streaming[i], 0,this.global.tokenShop).subscribe((data: any) => {
        if (data.hasError == false) {
          if (streaming.length == (i + 1)) {
            this.loadingScreenService.stopLoading();
            this.next.emit([this.infoStreaming,'delete']);
          }
        }
        else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.errorDesc);
        }
      });
    }
    if (streaming.length == 0) {
      this.next.emit([this.infoStreaming,'continue']);
    }
  }
  updateQuantity(quantity: number) {
    this.quantity = quantity;
    let opt = '';
    if (this.contractInMoths > 0) {
      opt = String(this.contractInMoths);
    }
    else {
      opt = 'withoutContract';
    }
    this.calculateAmountToPay(opt, this.contractIndex);
  }
  continueToPay(check: boolean) {
    if (check == true) {
      this.calculateDataHeader();
      this.selectMonthlyRentOut.emit(this.selectMonthlyRent);
      this.selectPayTodayOut.emit(this.selectPayToday);
      this.loadingScreenService.startLoading();
      this.services.addToCartIPTV(this.global.tokenShop,this.contract, this.contractInMoths, this.quantity, this.month,"8").subscribe(data => {
        this.loadingScreenService.stopLoading();
        if (data.hasError == false) {
          this.selectMonthlyRent[this.indexTab]=this.priceMonth;
          this.selectMonthlyRentOut.emit(this.selectMonthlyRent);
          this.updateinfoStreaming.emit(this.infoStreaming);
          this.next.emit([this.infoStreaming,'save']);
        }
        else {
          this.global.notif(data.errorDesc);
        }
      });
    }
    else {
      this.global.notif("Por favor acepte los términos y condiciones.");
    }
  }
  addCart() {
    let decPrice: any;
    let downPayment: number = this.infoStreaming.colors[0].storages[0].products[0].downPayment;
    this.selectMonthlyRent[this.indexTab] = 0;
    this.selectPayToday[this.indexTab] = 0;
    let month: number = 0;
    if (this.regularPriceCheck === false) {
      this.global.buyType = 'update';
      sessionStorage.setItem("buyType", this.global.buyType);
      decPrice = this.priceMonth;
      this.selectMonthlyRent[this.indexTab] = this.priceMonth * this.quantity;
      month = this.month;
    }
    else {
      this.global.buyType = 'full';
      sessionStorage.setItem("buyType", this.global.buyType);
      decPrice = this.regularPrice;
      this.selectPayToday[this.indexTab] = this.regularPrice * this.quantity;
    }
    this.selectMonthlyRentOut.emit(this.selectMonthlyRent);
    this.selectPayTodayOut.emit(this.selectPayToday);
    sessionStorage.setItem('buyType', this.global.buyType);
    sessionStorage.setItem('deviceType', this.global.deviceType);
    this.loadingScreenService.startLoading();
    if (this.cartIdStreaming == 0) {
      let items = this.global.addToCart(0, 0, this.infoStreaming.productId, this.global.creditClass, decPrice, downPayment, this.regularPrice, this.quantity, month);
      this.global.sendCart(items,this.infoStreaming.productId).subscribe(hasError => {
        if (hasError == false) {
          this.loadingScreenService.stopLoading();
          this.updateinfoStreaming.emit(this.infoStreaming);
          this.next.emit();
        }
      });
    }
    else {
      this.services.deleteItem(this.cartIdStreaming, 0, this.global.tokenShop).subscribe((data: any) => {
        if (data.hasError == false) {
          this.global.getCart().subscribe((data: any) => {
            let items = this.global.addToCart(0, 0, this.infoStreaming.productId, this.global.creditClass, decPrice, downPayment, this.regularPrice, this.quantity, month);
            this.global.sendCart(items,this.infoStreaming.productId).subscribe(hasError => {
              if (hasError == false) {
                this.loadingScreenService.stopLoading();
                this.updateinfoStreaming.emit(this.infoStreaming);
                this.next.emit();
              }
            });
          });
        }
      });
    }
  }
  selectMonths(index: number) {
    for (let i = 0; i < this.prices.length; i++) {
      this.prices[i].defaultPrice = false;
    }
    this.month = this.prices[index].intMonths;
    this.prices[index].defaultPrice = true;
    this.priceMonth = this.amountPayable / this.month;
    if (this.amountPayable == 0 || this.contract == false) {
      this.regularPriceCheck = true;
    }
    else {
      this.regularPriceCheck = false;
    }
  }
  selectPaymentMethods(check: boolean) {
    this.regularPriceCheck = !check;
    if (this.regularPriceCheck) {
      this.viewMonths = false;
      this.continue = true;
      this.month = 0;
    }
    else {
      this.viewMonths = true;
    }
  }
  pupOpTermns() {
    let title = 'Términos y Condiciones Streaming';
    let templetePath = 'assets/template/terms-streaming.html';
    this.global.showTerms('template', title, templetePath, true,false).subscribe(data => {
      if (data == 'continue') {
        this.checkTerms = true;
      }
    });
  }
  calculateDataHeader() {
    let months:string=' ';
    if (this.typeOfContract == 'Sin Contrato') {
      this.selectPayToday[this.indexTab] = this.amountPayable;
      this.selectPayTodayOut.emit(this.selectPayToday);

    }
    else {
      this.selectPayToday[this.indexTab] = 0;
      this.selectPayTodayOut.emit(this.selectPayToday);
      if (this.priceMonth == 0) {

      }
      else if (this.regularPriceCheck == true) {
        this.selectPayToday[this.indexTab] = this.amountPayable;
        this.selectPayTodayOut.emit(this.selectPayToday);
      }
    }
    if(this.month!=0){
      months='|  Pago en '+this.month+' meses'
    }
    this.selectsToDisplay[this.indexTab] = ': ' + this.quantity + ' Dispositivo  | ' + this.typeOfContract + months;
    this.selectsToDisplayOut.emit(this.selectsToDisplay);
    this.selectsToDisplayFull[this.indexTab] = ': ' + this.quantity + ' Dispositivo  | ' + this.typeOfContract + months;
    this.selectsToDisplayFullOut.emit(this.selectsToDisplayFull);
  }
}
